import React, { useEffect, useRef, useState } from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";

// eslint-disable-next-line react/prop-types
function Message({ content }) {
  return <p>{content}</p>;
}

// eslint-disable-next-line react/prop-types
function Paypal({ productId, productQty, productprice, paypalResponse, setPaypalResponse }) {
  const [message, setMessage] = useState("");
  const createOrderHandlerRef = useRef(null);
  console.log("paypalResponse", paypalResponse);
  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    createOrderHandlerRef.current = async (data, actions) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_PAYPAL_URL}/api/orders`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            cart: [
              {
                id: productId,
                quantity: productQty,
                productprice: productprice,
                currency_code: "USD"
              }
            ],
            application_context: {
              shipping_preference: "NO_SHIPPING"
            }
          })
        });

        const orderData = await response.json();

        if (orderData.id) {
          return orderData.id;
        } else {
          const errorDetail = orderData?.details?.[0];
          const errorMessage = errorDetail
            ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
            : JSON.stringify(orderData);

          throw new Error(errorMessage);
        }
      } catch (error) {
        console.error(error);
        setMessage(`Could not initiate PayPal Checkout...${error}`);
      }
    };
  }, [productId, productQty, productprice]);

  return (
    <div>
      <PayPalButtons
        style={{ shape: "rect", layout: "vertical" }}
        createOrder={(data, actions) => createOrderHandlerRef.current(data, actions)}
        onApprove={async (data, actions) => {
          try {
            const response = await fetch(
              `${process.env.REACT_APP_PAYPAL_URL}/api/orders/${data.orderID}/capture`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" }
              }
            );
            const orderData = await response.json();
            setPaypalResponse(orderData);

            const errorDetail = orderData?.details?.[0];
            if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
              return actions.restart();
            } else if (errorDetail) {
              throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
            } else {
              const transaction = orderData.purchase_units[0].payments.captures[0];
              setMessage(`Transaction ${transaction.status}: ${transaction.id}`);
              //console.log("Capture result", JSON.stringify(orderData, null, 2));
            }
          } catch (error) {
            console.error(error);
            setMessage(`Sorry, your transaction could not be processed...${error}`);
          }
        }}
        onError={(err) => {
          console.error("PayPal error:", err);
          setMessage(`PayPal Error: ${err.message}`);
        }}
      />
      <Message content={message} />
    </div>
  );
}

export default Paypal;
